import React, { useEffect, useState } from 'react'
import { useText } from '../context/TextContext'
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, FormSelect } from 'react-bootstrap';
import { AdvancedButton } from '../components/AdvancedButton';
import { CARD_LAYOUT_FIELD, CardLayout, DEFAULT_CARD_LAYOUT } from '../models/shared/CardLayout';
import { useDeals } from '../hooks/useDeals';
import { DealCard } from '../components/DealCard';
import { Organization } from '../models/shared/Organization';
import { doc, setDoc } from 'firebase/firestore';
import { useFirestore } from 'reactfire';
import { COLLECTIONS } from '../utils/shared/constants';
import { useOrganization } from '../context/OrganizationContext';
import { toast } from 'react-toastify';

interface LayoutOption {
    label: string;
    value: CARD_LAYOUT_FIELD;
}

export default function CardEditPage() {
    const text = useText();
    const [processing, setProcessing] = React.useState(false);
    const [dirty, setDirty] = React.useState(false);
    const [layout, setLayout] = useState<CardLayout>(DEFAULT_CARD_LAYOUT)
    const { allDeals } = useDeals({ limit: 10 });
    const firestore = useFirestore();
    const { orgId, organization } = useOrganization();
    const navigate = useNavigate();

    const options: LayoutOption[] = [
        { label: '', value: CARD_LAYOUT_FIELD.EMPTY },
        { label: text.name, value: CARD_LAYOUT_FIELD.NAME },
        { label: text.address, value: CARD_LAYOUT_FIELD.ADDRESS },
        { label: text.offer, value: CARD_LAYOUT_FIELD.OFFER },
        { label: text.updatedAt, value: CARD_LAYOUT_FIELD.UPDATED_AT },
    ]

    useEffect(() => {
        if (!organization.cardLayout) {
            return;
        }
        setLayout(organization.cardLayout)
    }, [organization.cardLayout])

    const renderOptions = () => {
        return <>
            {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </>
    }

    const handleChange = (key: keyof CardLayout, value: any) => {
        setLayout({ ...layout, [key]: value })
        setDirty(true)
    }

    const handleSave = async () => {
        setProcessing(true);
        try {
            const orgUpdate: Partial<Organization> = {
                cardLayout: layout
            }
            await setDoc(doc(firestore, COLLECTIONS.ORGANIZATIONS, orgId), orgUpdate, { merge: true });
            toast.success(text.defaultSuccess);
            navigate('/');
            return;
        } catch (e) {
            console.error(e);
            toast.error(text.defaultError)
        }

        setProcessing(false);
        setDirty(false);
    }

    return (
        <div className="d-flex flex-column gap-4">
            <div className='d-flex justify-content-between align-items-start'>

                <div>
                    <h2 className='m-0'>{text.changeLayout}</h2>
                    <p>{text.changeLayoutDescription}</p>
                </div>

                <div className='d-flex gap-2'>
                    <Link to={'/'}><Button variant='outline-secondary'>{text.cancel}</Button></Link>
                    <AdvancedButton onClick={() => handleSave()} processing={processing} icon="bi-floppy" disabled={!dirty} variant='primary'>{text.save}</AdvancedButton>
                </div>

            </div>

            <div className='center'>
                <Card
                    className='shadow-sm deal-card'

                >
                    <Card.Body className='d-flex flex-column gap-3'>
                        <div className='d-flex justify-content-between'>
                            <div className='d-flex flex-column gap-2'>
                                <FormSelect value={layout.title} onChange={e => handleChange('title', e.target.value)} >{renderOptions()}</FormSelect>
                                <FormSelect size='sm' value={layout.subtitle} onChange={e => handleChange('subtitle', e.target.value)} >{renderOptions()}</FormSelect>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <div></div>
                            <div>

                                <FormSelect size='sm' value={layout.rightBottom} onChange={e => handleChange('rightBottom', e.target.value)} >{renderOptions()}</FormSelect>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>

            <div>
                <h4>{text.preview}</h4>
                <div className='d-flex gap-3 overflow-auto'>
                    {allDeals.map(deal => <DealCard layout={layout} key={deal.id} deal={deal} preview />)}
                </div>
            </div>
        </div>
    )
}
